module.exports = __webpack_public_path__ + "img/Cleric.fd4c817f.png";